export const fieldsList = [
  "full_name",
  "donor_id",
  "phone_number",
  "email",
  "date_of_birth",
  "donation_amount",
  "status",
  "processing_agency",
  "residential_address",
  "city",
  "state",
  "zip_code",
  "donor_category",
  "gender",
  "occupation",
  "want_80g",
  "start_date",
  "remarks",
  "donation_frequency",
  "mode",
  "pan_no",
];
